import PDFMake from 'pdfmake/build/pdfmake.min.js';
import vfs_fonts from 'pdfmake/build/vfs_fonts.js';
import { invoiceLogo, invoiceLogoReverse } from './datauris.js';

function expandAddress(shipping_addr, billing_addr, customer_name){
  let aobj = JSON.parse(shipping_addr);
  // console.log(aobj);
  let address_array = [];//[ aobj.name, aobj.address_1 ];
  if(String(aobj.name).trim().length > 0){
    address_array.push(aobj.name);
  } else {
    address_array.push(customer_name);
    aobj = JSON.parse(billing_addr);
  }
  address_array.push(aobj.address_1);
  if(aobj.hasOwnProperty('address_2') && String(aobj.address_2.trim()).length > 0){
    address_array.push(aobj.address_2);
  }
  return address_array.concat([
    aobj.town,
    aobj.county,
    aobj.postcode
  ]).join("\n");
}

export default {
  methods : {
    getBarcodeImage : function(number){
      // console.log({ number });
      return new Promise((resolve, reject) => {
        this.callAPI('get', `/barcode/${number}`)
          .then((res) => {
            return resolve(String(res.data));
          })
          .catch(reject);
      });
    },
    openInvoicePDF : function(order, order_lines, surplus, batches){
      PDFMake.vfs = vfs_fonts.pdfMake.vfs;
      // let customer_address = (order.customer_name+"\n"+order.address+"\n"+order.postcode).toUpperCase();
      let customer_address = ""; //order.customer_name +"\n";
      if(order.company && String(order.company).trim().length){
        customer_address += order.company +"\n";
      }
      customer_address = (customer_address + expandAddress(order.shipping_address, order.address_json, order.customer_name)).toUpperCase();
      // (`${order.customer_name}\n${expandAddress(order.shipping_address)}`).toUpperCase(); // +"\n"+order.postcode
      let total_items = 0;
      let total_weight = 0;
      let invoice_lines = [[
        {text:(batches ? 'QTY' : 'ID'),bold:true,fillColor:'black',color:'white'}, 
        {text:'SKU',bold:true,fillColor:'black',color:'white'},
        {text:'Product',bold:true,fillColor:'black',color:'white'},
        // {text:'Title',bold:true,fillColor:'black',color:'white'},
        {text:'Price',bold:true,fillColor:'black',color:'white',alignment:'right'}
      ]];
      order_lines.forEach((ol) => {
        total_items = total_items + (batches ? parseInt(ol.quantity, 10) : 1);
        total_weight = total_weight + (batches ? (parseInt(ol.quantity, 10) * parseFloat(ol.weight)) : parseFloat(ol.weight));
        invoice_lines.push([
          (batches ? ol.quantity : ol.product_id),
          ol.sku,
          `${ol.title}` 
              + (batches ? ` @ ${this.formatMoney(ol.price)}` : ``) 
              + (parseInt(ol.substituted, 10) > 0 ? `\nTHIS LINE HAS BEEN SUBSTITUTED, SEE BELOW` : ``), //  - [SKU: ${ol.sku}]
          { text : this.formatMoney((batches ? ol.total : ol.price)), alignment : 'right' }
        ]);
      });

      let surplus_lines = [[
        {text:'QTY', bold:true, fillColor:'black', color:'white'}, 
        {text:'SKU', bold:true, fillColor:'black', color:'white'},
        {text:'Product', bold:true, fillColor:'black', color:'white'}
      ]];
      Object.keys(surplus).forEach((k) => {
        total_weight = total_weight + (batches ? (parseInt(surplus[k].quantity, 10) * parseFloat(surplus[k].weight)) : parseFloat(ol.weight));
        surplus_lines.push([
          parseInt(surplus[k].quantity, 10),
          surplus[k].sku,
          surplus[k].title
        ]);
      });

      // let vat = order_lines.reduce((sum, ol) => { return sum + parseFloat(ol.tax); }, 0);
      let tax = parseFloat(order.tax_total); // + parseFloat(order.shipping_tax_total);
      let shipping_total = parseFloat(order.shipping_cost);
      let subtotal = (batches
        ? order_lines.reduce((sum, ol) => { return sum + parseFloat(ol.total); }, 0)
        : order_lines.reduce((sum, ol) => { return sum + parseFloat(ol.price); }, 0)
      );

      
      this.getBarcodeImage(order.id)
        .then((barcode_image) => {
          var docDefinition = {
            content: [
              {
                columns : [
                  {
                    image     : invoiceLogoReverse(), //invoiceLogo(),
                    width     : 150,
                    alignment : 'right'
                  },
                  {
                    text : [
                      { text : "Raw Made Simple | Handmade Raw Dog Food | Made In The UK", bold : true },
                      { text : "\n\nRaw Made Simple Ltd.\nUnit 1, Little Mountains Farm\nMountains Road\nGreat Totham\nCM9 8BY" },
                      { text : "\n\nVAT number:\n289099439" }
                    ],
                    fontSize : 10,
                    alignment : 'right'
                  }
                ]
              },
              "\n\n\n",
              {
                columns : [
                  {
                    text : [
                      { text : "INVOICE", bold : true, fontSize : 18 },
                      { text : "\n\n"+customer_address, fontSize : 10 },
                      { text : "\n\n"+order.email+"\n"+order.telephone }
                    ],
                    alignment : 'left'
                  },
                  [
                    {
                      image     : barcode_image, //invoiceLogo(),
                      width     : 100,
                      alignment : 'right'
                    },
                    {
                      text : [
                        { text : "Order # "+order.id },
                        { text : `\n\nNet Wt. ${(total_weight / 1000)}kg` },
                        { text : "\n\n"+this.unixToExpandedDate(order.order_date) },
                        { text : "\n\n"+order.payment_method },
                        { text : "\n"+order.shipping_method },
                        { text : (order.delivery_date
                          ? "\n\nDelivery date: "+this.unixToJustDate(order.delivery_date)
                          : "") }
                      ],
                      fontSize : 10,
                      alignment : 'right'
                    }
                  ]
                ]
              },
              "\n",
              { text : (order.delivery_notes ? `Customer note:\n${order.delivery_notes}` : ""), fontSize : 10, alignment : 'center' },
              "\n",
              
              {
                style : 'tableExample',
                table : {
                  widths     : [40, 30, '*', 50],
                  headerRows : 1,
                  body       : invoice_lines
                },
                layout : {
                  hLineWidth: function(i, node){
                    return 0;
                  },
                  vLineWidth: function(i, node){
                    return 0;
                  },
                  fillColor : function(i, node){
                    return (i % 2 === 0) ? null : '#eeeeee';
                  }
                }
              },
              { text : `Total number of items: ${total_items}`, italics : true, fontSize : 10, alignment : 'left' },
              {
                columns : [
                  {
                    // EMPTY COLUMN
                  },
                  {
                    // EMPTY COLUMN
                  },
                  {
                    style : 'tableExample',
                    table : {
                      widths     : ['*', '*'],
                      headerRows : 0,
                      body       : [
                        ['Subtotal', { text: this.formatMoney(subtotal), alignment : 'right' }],
                        ['Postage', { text: this.formatMoney(shipping_total), alignment : 'right' }],
                        ['VAT', { text: this.formatMoney(tax), alignment : 'right' }],
                        [{ text: 'Total', bold : true }, { text: this.formatMoney(subtotal + shipping_total + tax), bold : true, alignment : 'right' }]
                        
                      ]
                    },
                    layout : {
                      hLineWidth: function(i, node){ 
                        // return (i === 3 || i === 4 ? 2 : 0);
                        return (i === 3 || i === 4 ? 2 : 0);
                      },
                      vLineWidth: function(i, node){ return 0; },
                      hLineColor: function (i, node) {
                        return 'black';
                      }
                    }
                  }
                ]
              }
            ],
            styles: {
              address : {
                fontSize  : 10,
                alignment : 'center'

              },
              heading : {
                fontSize : 22,
                bold     : true
              },
              tableExample : {
                margin : [0, 0, 0, 0],
                fontSize : 10
              }
            }
          };
          if(surplus_lines.length > 1){
            docDefinition.content.push(
              "\n",
              { text : `Substituted and/or additional products:`, fontSize : 10, alignment : 'left' },
              {
                style : 'tableExample',
                table : {
                  widths     : [40, 30, '*'],
                  headerRows : 1,
                  body       : surplus_lines
                },
                layout : {
                  hLineWidth: function(i, node){
                    return 0;
                  },
                  vLineWidth: function(i, node){
                    return 0;
                  },
                  fillColor : function(i, node){
                    return (i % 2 === 0) ? null : '#eeeeee';
                  }
                }
              }
            )
          }
          PDFMake.createPdf(docDefinition).open();
      })
      .catch((err) => { console.error(err); });
    },
    openPicklistPDF : function(order, order_lines){
      PDFMake.vfs = vfs_fonts.pdfMake.vfs;
      let picklist_lines = [[{text:'#',bold:true}, {text:'SKU',bold:true},{text:'Title',bold:true}]];
      order_lines.forEach((ol) => {
        picklist_lines.push([
          ol.product_id,
          ol.sku,
          ol.title
        ]);
      });
      var docDefinition = {
        content: [
          {
            columns : [
              {
                text : [
                  { text : "Picklist for", bold : true },
                  { text : "\n#"+order.id+" / "+this.unixToJustDate(order.order_date) },
                  { text : (order.delivery_date
                    ? "\nDelivery date: "+this.unixToJustDate(order.delivery_date)
                    : ""), 
                    fontSize : 10 }
                ],
                alignment : 'left'
              },
              {
                image     : invoiceLogo(),
                width     : 150,
                alignment : 'right'
              },
              {
                text  : order.customer_name+"\n"+order.email+"\n"+order.telephone,
                fontSize : 10,
                alignment : 'right'
              }

            ]
          },
          {
            style : 'table',
            table : {
              widths     : [50, 50, '*'],
              headerRows : 1,
              body       : picklist_lines
            },
            layout : {
              hLineWidth: function(i, node){
                return 0;
              },
              vLineWidth: function(i, node){
                return 0;
              },
              fillColor : function(i, node){
                return (i % 2 === 0) ? null : '#eeeeee';
              }
            }
          }

        ],
        styles: {
          table : {
            margin : [0, 5, 0, 15]
          }
        }
      };
      PDFMake.createPdf(docDefinition).open();
    }
  }
};


// WEBPACK FOOTER //
// ./src/mixins/pdf_mixins.js